import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteFlashMessage } from "../../actions/FlashMessagesAction";
import FlashMessage from "./FlashMessage";

export default function FlashMessagesList() {
  const messages = useSelector((state) => state.flashMessages);
  const dispatch = useDispatch();
  const deleteFlashMessageHandler = useCallback(
    (id) => dispatch(deleteFlashMessage(id)),
    [dispatch],
  );

  return (
    <div>
      {messages?.map((message) => (
        <FlashMessage
          key={message.id}
          message={message}
          deleteFlashMessage={deleteFlashMessageHandler}
        />
      ))}
    </div>
  );
}
